import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { AngularSvgIconModule } from "angular-svg-icon";

@Component({
  selector: "app-card-category-icon",
  templateUrl: "./card-category-icon.component.html",
  styleUrls: ["./card-category-icon.component.scss"],
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
// Pure display component — all values are pre-computed by the typed card component (parent).
// No colour or folder logic here: typed cards pass iconFolder, iconPrefix, and iconColorClass directly.
export class CardCategoryIconComponent {
  /** SafetyCardCategory string value ('body', 'feelings', etc.) or activity slug ('anchor', 'activity'). null → no icon. */
  @Input() category: string | null = null;
  /** Asset subfolder: 'activity-cards' | 'safety-cards' */
  @Input() iconFolder: string = "";
  /** Filename prefix: 'ac-' | 'sc-' */
  @Input() iconPrefix: string = "";
  /** CSS class for icon colour, e.g. 'icon-wild-hare'. Empty string → default dark (forest-path). */
  @Input() iconColorClass: string = "";
  @Input() isMediaCard: boolean = false;
  @Input() mediaIcon: string = "fas fa-film";
}
